import React from 'react';
import { FaUserMd, FaMapMarkerAlt, FaPhoneAlt, FaTag, FaUser, FaKey } from 'react-icons/fa';

const DoctorProfile = ({ doctor }) => {
  const cardStyle = {
    perspective: '1000px',
    width: '300px',
    height: '200px',
    margin: '20px',
    cursor: 'pointer',
  };

  const cardInnerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%',
    transition: 'transform 0.6s cubic-bezier(0.68, -0.55, 0.265, 1.55)',
    transformStyle: 'preserve-3d',
  };

  const cardFrontStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backfaceVisibility: 'hidden',
    backgroundColor: '#f0f4f8',
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2)',
  };

  const cardBackStyle = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backfaceVisibility: 'hidden',
    backgroundColor: '#1e88e5',
    color: 'white',
    borderRadius: '10px',
    transform: 'rotateY(180deg)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-evenly',
    padding: '20px',
    boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2)',
  };

  const iconStyle = {
    fontSize: '1.5em',
    marginBottom: '5px',
    color: '#3f51b5',
  };

  const backIconStyle = {
    fontSize: '1.2em',
    marginRight: '10px',
    color: 'white',
  };

  const nameStyle = {
    fontSize: '1.5em',
    fontWeight: 'bold',
    marginBottom: '10px',
    textAlign: 'center',
    color: '#283593',
  };

  const typeStyle = {
    fontSize: '1em',
    color: '#757de8',
    marginBottom: '15px',
  };

  const infoStyle = {
    fontSize: '0.9em',
    marginBottom: '8px',
    textAlign: 'left',
  };

  const [isFlipped, setIsFlipped] = React.useState(false);

  const handleCardFlip = () => {
    setIsFlipped(!isFlipped);
  };

  const flippedStyle = isFlipped ? { transform: 'rotateY(180deg)' } : {};

  return (
    <div style={cardStyle} onMouseEnter={handleCardFlip} onMouseLeave={handleCardFlip}>
      <div style={{ ...cardInnerStyle, ...flippedStyle }}>
        <div style={cardFrontStyle}>
          <FaUserMd style={iconStyle} />
          <div style={nameStyle}>{doctor.doctorName}</div>
          <div style={typeStyle}>{doctor.doctorType}</div>
        </div>
        <div style={cardBackStyle}>
          <div style={infoStyle}>
            <FaTag style={backIconStyle} /> Type: {doctor.doctorType}
          </div>
          <div style={infoStyle}>
            <FaMapMarkerAlt style={backIconStyle} /> Address: {doctor.clinicAddress}
          </div>
          <div style={infoStyle}>
            <FaPhoneAlt style={backIconStyle} /> Call: {doctor.clinicNumber}
          </div>
          {doctor.userId && (
            <div style={infoStyle}>
              <FaUser style={backIconStyle} /> User ID: {doctor.userId}
            </div>
          )}
          {doctor.id && (
            <div style={infoStyle}>
              <FaKey style={backIconStyle} /> Doctor ID: {doctor.id}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const DoctorProfileList = () => {
  // Dummy doctor data based on your class fields
  const doctorsData = [
    {
      id: 1,
      userId: 101,
      doctorName: 'Dr. Rajesh Kumar',
      doctorType: 'Cardiologist',
      clinicAddress: '123 Main Street, Anytown',
      clinicNumber: '9876543210',
    },
    {
      id: 2,
      userId: 102,
      doctorName: 'Dr. Priya Sharma',
      doctorType: 'Pediatrician',
      clinicAddress: '456 Park Avenue, Somecity',
      clinicNumber: '8765432109',
    },
    {
      id: 3,
      userId: null, // userId might be null
      doctorName: 'Dr. Aman Verma',
      doctorType: 'Neurologist',
      clinicAddress: '789 Elm Road, Otherville',
      clinicNumber: '7654321098',
    },
  ];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
      {doctorsData.map(doctor => (
        <DoctorProfile key={doctor.id} doctor={doctor} />
      ))}
    </div>
  );
};

export default DoctorProfileList;